import SecurityAndAccess from "./SecurityAndAccess";
import GeneralAminInfo from "./GeneralAminInfo";
import PersonalInfo from "./PersonalInfo";

const AdminInformation = ({
  userId,
  isEdit,
}: {
  userId?: string;
  isEdit?: boolean;
}) => {
  return (
    <div className="flex flex-col gap-4">
      <GeneralAminInfo />
      {isEdit && <SecurityAndAccess userId={userId} isEdit={isEdit} />}
      <PersonalInfo />
    </div>
  );
};

export default AdminInformation;
